import { render } from "./Scoring.vue?vue&type=template&id=64c66372"
import script from "./Scoring.vue?vue&type=script&lang=js"
export * from "./Scoring.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__